/**
 * オフラインエラー
 * ネットワーク接続不良の場合にスローされる
 * 
 * @author CAP
 */
export class OfflineError extends Error {
  constructor(message: string = 'ネットワーク接続が不良です') {
    super(message);
    this.name = 'OfflineError';
    Object.setPrototypeOf(this, OfflineError.prototype);
  }
}